import { LabelVariant } from '@sharedCR/coreDesignSystem/LabelCDS/LabelCDS.constants';

import { PostClosingOptionListType } from 'constants/postClosingOptions';

export const OVERVIEW_SKELETONS_LENGTH = 4;

const ServicingStatus = {
  ACTIVE: 1,
  RELEASED: 2,
  PAID_OFF: 3,
  FORECLOSED: 4,
  PENDING_SERVICING: 5,
};

export const servicingStatusOptions = [
  { value: ServicingStatus.ACTIVE, name: 'Active' },
  { value: ServicingStatus.RELEASED, name: 'Released' },
  { value: ServicingStatus.PAID_OFF, name: 'Paid Off' },
  { value: ServicingStatus.FORECLOSED, name: 'Foreclosed' },
  { value: ServicingStatus.PENDING_SERVICING, name: 'Pending Servicing' },
];

export const SERVICING_STATUS_LABEL_VARIANT = {
  [ServicingStatus.ACTIVE]: LabelVariant.GREEN,
  [ServicingStatus.RELEASED]: LabelVariant.GRAY,
  [ServicingStatus.PAID_OFF]: LabelVariant.BLUE,
  [ServicingStatus.FORECLOSED]: LabelVariant.RED,
  [ServicingStatus.PENDING_SERVICING]: LabelVariant.ORANGE,
};

export const POST_CLOSING_LONG_TEXT_MAX_LENGTH = 2000;

export const POST_CLOSING_SHORT_TEXT_MAX_LENGTH = 255;

export const SELECT_PLACEHOLDER = 'Select…';

export const POST_CLOSING_OPTION_LIST_TYPE_BY_FIELD = {
  minDeactivationType: PostClosingOptionListType.MIN_DEACTIVATION_TYPE,
  unsalableResponsibleParty: PostClosingOptionListType.UNSALABLE_RESPONSIBLE_PARTY,
  unsalableReason: PostClosingOptionListType.UNSALABLE_REASON,
};
